const getSizeClass = (size: string) => {
  switch (size) {
    case '8':
      return 'textTiny'
    case '10':
      return 'textXs'
    case '12':
      return 'textSm'
    case '14':
      return 'textBase'
    case '18':
      return 'textLg'
    case '24':
      return 'textXl'
    default:
      return ''
  }
}

const getWeightClass = (weight: string) => {
  switch (weight) {
    case 'regular':
      return 'fontNormal'
    case 'semibold':
      return 'fontSemibold'
    case 'bold':
      return 'fontBold'
    case 'light':
      return 'fontLight'
    default:
      return ''
  }
}

const getColorClass = (color: string) => {
  switch (color) {
    case 'black-main':
      return 'textBlackMain'
    case 'black-3':
      return 'textBlack3'
    case 'blue-main':
      return 'textBlueMain'
    case 'white':
      return 'textWhite'
    default:
      return ''
  }
}

const getFontFamilyClass = (fontFamily: string) => {
  switch (fontFamily) {
    case 'proxima':
      return 'fontProxima'
    default:
      return 'fontProxima'
  }
}

interface ClassStyles {
  size: string
  underline: boolean
  italic: boolean
  weight: string
  color: string
  fontFamily: string
  initialClassName?: string
}

export const getClassNames = ({
  size,
  underline,
  italic,
  weight,
  color,
  fontFamily,
  initialClassName,
}: ClassStyles) => {
  const classNames = [
    initialClassName,
    getSizeClass(size),
    underline && 'textUnderline',
    italic && 'fontItalic',
    getWeightClass(weight),
    getColorClass(color),
    getFontFamilyClass(fontFamily),
  ].filter((element) => {
    if (element !== '' && element) {
      return element
    }

    return false
  }) as string[]

  return classNames
}
